module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo4-e50c61c5fb293337c5097db9a99df3db.jpg";